module.exports = __webpack_public_path__ + "img/fingerscan.3086c76c.jpg";